import React from 'react';
import { Grid } from '@mui/material';

const BestWorstInputs = ({ bestValue, setBestValue, worthValue, setWorthValue, isReadOnly, onFocus }) => (
  <Grid display="flex" alignItems="center" justifyContent="space-between">
    <input
      placeholder="بدترین متن را تایپ کنید"
      value={worthValue}
      onChange={(e) => setWorthValue(e.target.value)}
      onFocus={isReadOnly ? null : onFocus}
      readOnly={isReadOnly}
      style={{
        border: 'none',
        outline: 'none',
        fontSize: '12px',
        fontWeight: 500,
        color: 'rgb(44, 51, 69)',
        width: '50px',
      }}
    />
    <input
      placeholder="بهترین متن را تایپ کنید"
      value={bestValue}
      onChange={(e) => setBestValue(e.target.value)}
      onFocus={isReadOnly ? null : onFocus}
      readOnly={isReadOnly}
      style={{
        border: 'none',
        outline: 'none',
        fontSize: '12px',
        fontWeight: 500,
        color: 'rgb(44, 51, 69)',
        width: '50px',
      }}
    />
  </Grid>
);

export default BestWorstInputs;
